import CapsulaModel from "../models/capsulaModel";
import ProdutoModel from "../models/produto/produtoModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class CapsulaService extends iServiceCached<CapsulaModel> {
    constructor() {
        super("Capsula");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);

        return retorno
            .filter(p => p["franquiaId"] == null || p["franquiaId"] == franquiaId)
            .map(item => ({
                value: item.id,
                text: item.descricao,
            }));
    }

    public produtosCores(id: number) {
        return nfetch(`/${this.controllerName}/GetProdutosCores?id=${id}`, {
            credentials: "same-origin",
        }).resolveWithJSON<ProdutoModel[]>();
    }

    public salvarOrdem(produtos: ProdutoModel[]) {
        return nfetch(`/${this.controllerName}/SalvarOrdem`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(produtos),
        })
            .withLoading()
            .resolveWithoutJSON();
    }
}

export default new CapsulaService();
